/**
 * Custom Link wrapper that disables Next.js prefetch globally.
 * Import from '@/modules/shared/components/Link' instead of 'next/link'.
 */
import NextLink, { LinkProps } from 'next/link'
import { AnchorHTMLAttributes } from 'react'

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> &
  LinkProps & {
    children?: React.ReactNode
  }

export default function Link({ prefetch = false, ...props }: Props) {
  return <NextLink prefetch={prefetch} {...props} />
}
